<template>
  <div
    class="pt-1 pb-1 large-group-times-ui -silver_border_bottom"
    v-show="activity.AppointmentDate"
  >
    <!-- <h3>Large Group Mode</h3> -->

    <!-- <p v-if="!activity.AppointmentDate" class="bg-gray p-1 border_radius flex_start">
      <i class="material-icons mr-1">priority_high</i> Select date and add guests to see available times
    </p>-->

    <p
      v-if="isLargeGroup"
      class="bg-gray pl-2 pr-2 pt-1 pb-1 mb-2 border_radius flex_start"
    >
      <!-- <i class="material-icons mr-1">notifications</i> -->
      Since you have a large group, you will need to divide your group across
      multiple times. Select a time to get started.
    </p>

    <ul class="list times" v-if="activity.Times">
      <large-group-times-ui-row
        v-for="(time, i) in activity.Times"
        :key="
          'large-group-times-activity-times-' +
            time.Value +
            '-' +
            i +
            '-' +
            activity.EntityHierarchyKey
        "
        :id="radioName + '-activity-times-' + time.Value"
        :value="time.Value"
        :name="radioName"
        :activity="activity"
        :time="time"
        :isLoading="isLoading"
        @input="updateInput"
        :enableRateDuration="activity.CapacityTypeKey == 2 || activity.CapacityTypeKey == 3"
        :entityHierarchyKey="activity.EntityHierarchyKey"
        :hideUnselectedTimes="hideUnselectedTimes"
        @showUnselectedTimes="$emit('showUnselectedTimes', {})"
      />
    </ul>
  </div>
</template>

<script>
//import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

import LargeGroupTimesUiRow from "../components/LargeGroupTimesUiRow.vue";

export default {
  name: "LargeGroupTimeUI",
  props: ["radioName", "activity", "isLargeGroup", "hideUnselectedTimes", "isLoading"],
  components: {
    LargeGroupTimesUiRow
  },
  computed: {
    //...mapState(["activeProductDetails"]),
    // activity() {
    //   if (this.activeProductDetails) {
    //     return this.activeProductDetails.Activities.find(act => {
    //       return (
    //         act.EntityHierarchyKey == this.$route.params.entityHierarchyKey
    //       );
    //     });
    //   }
    //   return false;
    // },
    hasAddons() {
      return this.activity.HasAddons;
    }
  },
  methods: {
    updateInput: function(val) {
      //alert("updateInput(val) " + val);

      if (this.activity.Times) {
        this.activity.Times.forEach(ele => {
          ele.IsSelected = false;
        });

        var find = this.activity.Times.find(ele => {
          return ele.Value == val;
        });

        find.IsSelected = true;
        //this.$emit("input", event.target.value);

        if (this.hasAddons) {
          //var r = this.$route.params;
          //var path ='/'+r.client + '/' + r.modify + '/activity/'+ r.id + '/' + r.clientAgentKey +'/addons/' + val;

          console.warn("TODO: move this to mixin");

          this.goToAddons({
            productType: "activity",
            entityHierarchyKey: this.activity.EntityHierarchyKey,
            timeId: val
          });
        }
      }
    }
  }
};
</script>

<style></style>
